import React from "react";
import { Form, Offcanvas, Spinner, Table } from "react-bootstrap";

const TableProperties = ({
  Show,
  Hide,
  Title,
  tableRef,
  onMouseDown,
  formDataColumn,
  tableColumns,
  buttonLoader,
  setTableColumns,
  updateTableProperties,
}) => {
  const handleCheckboxChange = (checked, column) => {
    setTableColumns((prev) => {
      const updated = { ...prev };
      if (checked) {
        delete updated[column];
      } else {
        updated[column] = true;
      }
      return updated;
    });
  };

  const handleSelectAllChange = (checked) => {
    if (checked) {
      setTableColumns({});
    } else {
      const allExcluded = {};
      formDataColumn.forEach((col) => {
        allExcluded[col] = true;
      });
      setTableColumns(allExcluded);
    }
  };

  const isChecked = (columnName) =>
    Object.keys(tableColumns).length === 0 || !tableColumns[columnName];

  const allSelected = Object.keys(tableColumns).length === 0;

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <Table ref={tableRef} className="m-0 custom-table" hover striped>
            <thead className="position-sticky top-0 z-1">
              <tr>
                <th
                  onMouseDown={(e) => onMouseDown(e, 0)}
                  style={{ width: 45 }}
                  className="text-center"
                >
                  <Form.Check
                    type="checkbox"
                    checked={allSelected}
                    onChange={(e) => handleSelectAllChange(e.target.checked)}
                  />
                </th>
                <th onMouseDown={(e) => onMouseDown(e, 1)}>Columns</th>
              </tr>
            </thead>
            <tbody>
              {formDataColumn?.map((col, index) => (
                <tr key={`dynamic-${index}`}>
                  <td className="text-center">
                    <Form.Check
                      type="checkbox"
                      checked={isChecked(col)}
                      onChange={(e) => handleCheckboxChange(e.target.checked, col)}
                    />
                  </td>
                  <td>{col}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm text-end">
          <button
            disabled={buttonLoader}
            onClick={updateTableProperties}
            className="updateProfile"
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm"/> Applying...
              </div>
            ) : (
              "Apply"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default TableProperties;
